import { DECREASE, INCREASE } from "./ActionIdentifier";

export const increase = (product, price, stock) => {
    return {
        type: INCREASE,
        payload: {
            product,
            price,
            stock,
        },
    };
};

export const decrease = (product, price) => {
    return {
        type: DECREASE,
        payload: {
            product,
            price,
        },
    };
};
